import * as actions from '../Actions/types';
import {can} from "../../util/functions";

const initSate = {
  users : []
};

const UserReducer = (state = initSate, action) => {

  switch (action.type) {

    case actions.GET_USERS: {
      let {users,authUser} = action.payload;
      users = users.filter(u => {
        if(u.SiteID === authUser.SiteID){
          return true;
        }
        return can("user-list-all",authUser.permissions);
      });
      return { ...state, users };

    }

    case actions.CREATE_USER: {
      return { ...state, users: [{...action.payload},...state.users] };
    }

    case actions.EDIT_USER: {
      const model = action.payload;
      let users = state.users.map( v => (v.UserID === model.UserID)?{...model}:{...v});
      return { ...state, users };
    }

  }
  return state;
};

export default UserReducer;
